<div>
    <mat-paginator *ngIf="paginator" #paginator [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 20]" [length]="subject?.length" (page)="changePage($event)"></mat-paginator>
    <table mat-table matSort [dataSource]="protocols" class="protocol-table">
        <ng-container matColumnDef="protocol">
            <th mat-header-cell *matHeaderCellDef style="display: none;"></th>
            <td mat-cell *matCellDef="let protocol">
                <app-protocol-row [record]="protocol" [mode]="'full'"></app-protocol-row>
            </td>
        </ng-container>
        <tr class="hide-header" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</div>